import React, { useState } from 'react'
import dummySVG from '../assets/svg/dummy.svg';

function BlurImg({ imgUrl, alt, cStyle }) {
    const [loaded, setLoaded] = useState(false);
    const imgStyle = cStyle ? cStyle : {
        objectFit: 'cover'
    }

    return (
        <div style={{ width: '100%', height: '100%', position: "relative", display: "inline-block" }}>
            {/* Low-resolution blurred image */}
            <img
                src={dummySVG}
                alt={alt ?? "Card_Image"}
                style={{
                    ...imgStyle,
                    width: '100%', height: '100%',
                    filter: "blur(20px)",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    // transition: "opacity 0.5s",
                    opacity: loaded ? 0 : 1,
                }}
            />

            {/* High-resolution image */}
            <img
                src={imgUrl}
                alt={alt ?? "Card_Image"}
                style={{
                    ...imgStyle,
                    width: '100%', height: '100%',
                    // transition: "opacity 0.5s",
                    opacity: loaded ? 1 : 0,
                }}
                onLoad={() => setLoaded(true)}
            />
        </div>
    );
};

export default BlurImg